export default {
  title: "Token Update",
  subtitle: "Follow the steps to update all your tokens and positions",
  connect: "Connect your wallet",
  disconnect: "Disconnect",
  switch_network: "Switch network",
  info: "You must update your old CNKT tokens to get the new CNKT+ token, with greater utility and added services. Click on the buttons below to proceed with the update. We will replicate, exactly the same, the position you had in the old CNKT but with the new CNKT+.",
  steps: {
    withdraw:
      "Withdraw your position from the different pools to get your tokens and LP by clicking the withdraw button on each of your positions.",
    approve: "Authorize the tokens so they can be updated later.",
    migrate:
      "Confirm the update. Here you can see the summary of everything you are going to update as well as the distribution of airdrops based on your positions. Keep in mind that the values are approximate (due to slippage).",
  },
  yields: {
    name: "Name",
    deposited: "Deposited",
    rewards: "Rewards",
    actions: "Actions",
    withdraw: "Withdraw",
    migrate: "Update",
  },
  approve: "Approve",
  loading: "Loading...",
  completed: {
    title: "You have no tokens to update",
    info: "You updated everything correctly, or simply you have no tokens to update in this wallet.",
    explorer: "View transaction in Explorer:",
    cta: "Go to DAPP",
  },
  error: {
    title: "Error loading update information",
    message: "There was an error loading your update data. Please try again later.",
    retry: "Try again",
  },
}
